module.exports = __webpack_public_path__ + "img/save_ico.42e61980.svg";